import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminClients from "./pages/AdminClients";
import AdminClientDetail from "./pages/AdminClientDetail";
import AdminPlanBuilder from "./pages/AdminPlanBuilder";
import AdminRecipes from "./pages/AdminRecipes";
import AdminRecipeDetail from "./pages/AdminRecipeDetail";
import AdminGuidelines from "./pages/AdminGuidelines";
import AdminCalendar from "./pages/AdminCalendar";
import ClientHome from "./pages/ClientHome";
import ClientPlan from "./pages/ClientPlan";
import ClientRecipes from "./pages/ClientRecipes";
import ClientRecipeDetail from "./pages/ClientRecipeDetail";

import ProtectedAdmin from "./components/ProtectedAdmin";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route element={<ProtectedAdmin />}>
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/clients" element={<AdminClients />} />
            <Route path="/admin/clients/:clientId" element={<AdminClientDetail />} />
            <Route path="/admin/clients/:clientId/plans/new" element={<AdminPlanBuilder />} />
            <Route path="/admin/plans/:planId/edit" element={<AdminPlanBuilder />} />
            <Route path="/admin/recipes" element={<AdminRecipes />} />
            <Route path="/admin/recipes/:recipeId" element={<AdminRecipeDetail />} />
            <Route path="/admin/guidelines" element={<AdminGuidelines />} />
            <Route path="/admin/calendar" element={<AdminCalendar />} />
          </Route>

          {/* Legacy client URLs (kept so already-shared links still work) */}
          <Route path="/client/:token" element={<ClientHome />} />
          <Route path="/client/:token/plan/:planId" element={<ClientPlan />} />
          <Route path="/client/:token/recipes" element={<ClientRecipes />} />
          <Route path="/client/:token/recipes/:recipeId" element={<ClientRecipeDetail />} />

          {/* New client URLs include the client name slug, e.g. /john-doe/<token> */}
          <Route path="/:nameSlug/:token" element={<ClientHome />} />
          <Route path="/:nameSlug/:token/plan/:planId" element={<ClientPlan />} />
          <Route path="/:nameSlug/:token/recipes" element={<ClientRecipes />} />
          <Route path="/:nameSlug/:token/recipes/:recipeId" element={<ClientRecipeDetail />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
